import { render, staticRenderFns } from "./IncomeHistoryModal.vue?vue&type=template&id=4edae4d8"
import script from "./IncomeHistoryModal.vue?vue&type=script&lang=js"
export * from "./IncomeHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports